import { HeightUnit, WeightUnit } from "@/Common/Utilities/Units/Units";
import { ObstetricalExamResultData } from "./ObstetricalExamResultData";

interface ISkinExamResultExtraInfo {
    HasSkinVaricosities: boolean;
    HasOtherSkinCondition: boolean;
    OtherSkinConditionDescription: string
}

interface IPelvicExamResultExtraInfo {
    SexuallyTransmittedInfectionExamDate?: Date;
    PapExamCompletionDate?: Date;
    Description: string;
    SexuallyTransmittedInfectionExamValue: string;
    PapExamResult: string;
}

class BritishColumbiaObstetricalFileInitialPhysicalExamination {
    public VitalSignEmrTemplateId: string;
    public ExaminationDate: Date = null;
    public CompletedBy: string;
    public PrePregnancyWeight: number;
    public PrePregnancyBodyMassIndex: number;
    public WeightUnit: WeightUnit;
    public HeightUnit: HeightUnit;

    public HeadAndNeckExamResult: ObstetricalExamResultData<string>;
    public BreastAndNipplesExamResult: ObstetricalExamResultData<string>;
    public HeartAndLungExamResult: ObstetricalExamResultData<string>;
    public AbdomenExamResult: ObstetricalExamResultData<string>;
    public MusculoskeletalExamResult: ObstetricalExamResultData<string>;
    public SkinExamResult: ObstetricalExamResultData<ISkinExamResultExtraInfo>;
    public PelvicExamResult: ObstetricalExamResultData<IPelvicExamResultExtraInfo>;
    public OtherExamResult: ObstetricalExamResultData<string>;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileInitialPhysicalExamination>) {
        Object.assign(this, fields);
        this.WeightUnit = fields?.WeightUnit ?? (sessionStore.useMetricSystemAsDefault ? WeightUnit.Kilogram : WeightUnit.Pound);
        this.HeightUnit = fields?.HeightUnit ?? (sessionStore.useMetricSystemAsDefault ? HeightUnit.Centimeter : HeightUnit.Inch);

        this.HeadAndNeckExamResult = new ObstetricalExamResultData<string>(fields?.HeadAndNeckExamResult);
        this.BreastAndNipplesExamResult = new ObstetricalExamResultData<string>(fields?.BreastAndNipplesExamResult);
        this.HeartAndLungExamResult = new ObstetricalExamResultData<string>(fields?.HeartAndLungExamResult);
        this.AbdomenExamResult = new ObstetricalExamResultData<string>(fields?.AbdomenExamResult);
        this.MusculoskeletalExamResult = new ObstetricalExamResultData<string>(fields?.MusculoskeletalExamResult);
        this.SkinExamResult = new ObstetricalExamResultData<ISkinExamResultExtraInfo>({
            Result: fields?.SkinExamResult?.Result,
            ExtraInfo: { ...fields?.SkinExamResult?.ExtraInfo }
        });
        this.PelvicExamResult = new ObstetricalExamResultData<IPelvicExamResultExtraInfo>({
            Result: fields?.PelvicExamResult?.Result,
            ExtraInfo: { ...fields?.PelvicExamResult?.ExtraInfo }
        });
        this.OtherExamResult = new ObstetricalExamResultData<string>(fields?.OtherExamResult);
    }

    public setEmptyFieldsAsNormal(): void {
        this.HeadAndNeckExamResult.setNormalResultIfNothingSet();
        this.BreastAndNipplesExamResult.setNormalResultIfNothingSet();
        this.HeartAndLungExamResult.setNormalResultIfNothingSet();
        this.AbdomenExamResult.setNormalResultIfNothingSet();
        this.MusculoskeletalExamResult.setNormalResultIfNothingSet();
        this.SkinExamResult.setNormalResultIfNothingSet();
        this.PelvicExamResult.setNormalResultIfNothingSet();
        this.OtherExamResult.setNormalResultIfNothingSet();
    }
}

export { BritishColumbiaObstetricalFileInitialPhysicalExamination, IPelvicExamResultExtraInfo };
